const pairFields = [
  {
    name: "Internal Pressure",
    pairs: ["txt_DP_CSC", "designInternalPressure", "txt_DP_EHC", "txt_DP_NC1"],
  },
  {
    name: "Design Temperature",
    pairs: ["txt_DT_CSC", "designTemperature", "txt_DT_EHC"],
  },
  {
    name: "Joint Efficiency",
    pairs: ["txt_JE_CSC", "jointEffLong", "txt_JE_EHC"],
  },
  {
    name: "Inside/Outside Diameter",
    pairs: [
      "vesselDiameter",
      "txt_ID_CSC",
      "txt_ID_EHC",
      "DataGridView5_Dia",
      "txt_SD_NC1",
      "txt_R_SC",
      "TxtBx_VOD",
    ],
  },
  {
    name: "Design Length of Shell",
    pairs: ["txt_DL_CSC", "vesselLengthSS", "DataGridView5_Can"],
  },
  {
    name: "External Pressure",
    pairs: ["externalPressureCSC", "designExternalPressure", "externalPressureEHC"],
  },
  {
    name: "Nozzle Stress",
    pairs: ["nozzleStress", "txt_NAS_NC1"],
  },
  {
    name: "Liquid Head Pressure",
    pairs: ["txt_LH_CSC", "txt_LH_EHC"],
  },
  {
    name: "Material Specification",
    pairs: ["txt_MS_CSC", "txt_MS_EHC"],
  },
  {
    name: "Corrosion Allowance",
    pairs: ["txt_CA_CSC", "txt_CA_EHC", "corrosionAllowanceShell"],
  },
  {
    name: "Allowable Stress", //shell
    pairs: [
      "txt_AS_CSC",
      "txt_AS_EHC",
      "txt_SAS_NC1",
      "shellStress",
      "txt_AS_SC",
    ],
  },
  {
    name: "Provided Thk",
    pairs: [
      "txt_PT_CSC",
      "txt_PT_EHC",
      "DataGridView5_thickness",
      "txt_SPT_NC1",
      "TxtBx_Wb_Thck",
    ],
  },
  {
    name: "Vessel Length: TT",
    pairs: ["txt_LS_SC", "vesselLengthTT"],
  },
  {
    name: "Support Distance From Ref",
    pairs: ["txt_SD_SC.Text", "TxtBx_A_1.Text"],
  },
  {
    name: "Material",
    pairs: ["Material", "shellMaterial", "headMaterial", "txt_MS_CSC", "txt_MS_EHC"],
  },
  {
    name: "Nozzle Material",
    pairs: ["Nozzle Material", "nozzleMaterial"],
  },
  {
    name: "Flange Material",
    pairs: ["Flange Material", "flangeMaterial"],
  },
  {
    name: "Pad Material",
    pairs: ["Pad Material", "rfPadMaterial"],
  },
  // {
  //     name: "Head Material",
  //     pairs: ["Head Material", "ComboBox11"]
  // },
  // {
  //     name: "Shell Material",
  //     pairs: ["Shell Material", "ComboBox9"]
  // },
  {
    name: "Saddle Dist",
    pairs: ["TxtBx_A_1", "txt_SD_SC"],
  },
  {
    name: "Contact Angle",
    pairs: ["txt_CA_SC", "TxtBx_Wb_CntctAngl"],
  },
];

export const pairFields2 = {
  "Internal Pressure": [
    "txt_DP_CSC",
    "designInternalPressure",
    "txt_DP_EHC",
    "txt_DP_NC1",
  ],
  "Design Temperature": ["txt_DT_CSC", "designTemperature", "txt_DT_EHC"],
  "Joint Efficiency": ["txt_JE_CSC", "jointEffLong", "txt_JE_EHC"],
  "Inside/Outside Diameter": [
    "vesselDiameter",
    "txt_ID_CSC",
    "txt_ID_EHC",
    "DataGridView5_Dia",
    "txt_SD_NC1",
  ],
  "Design Length of Shell": ["txt_DL_CSC", "vesselLengthSS"],
  "Design Length of Head": ["txt_LH_SC"],
  "External Pressure": ["externalPressureCSC", "designExternalPressure", "externalPressureEHC"],
  "Provided Thk": [
    "txt_PT_CSC",
    "txt_PT_EHC",
    "DataGridView5_thickness",
    "txt_SPT_NC1",
  ],
};

export default pairFields;
